import React from 'react';
import { formatCurrency } from '../../utils/formatters';

const ValueComparisonBar = ({ values, height = 60 }) => {
  // values format: [{ label, value, color }]
  const maxValue = Math.max(...values.map(v => v.value).filter(v => v !== null && v !== undefined));

  return (
    <div className="space-y-3">
      {values.map((item, index) => {
        if (!item.value) return null;
        
        const percentage = (item.value / maxValue) * 100;
        
        return (
          <div key={index} className="space-y-1">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium text-gray-700">{item.label}</span>
              <span className="text-sm font-bold text-gray-900">
                {formatCurrency(item.value)}
              </span>
            </div>
            <div className="relative w-full bg-gray-100 rounded-lg overflow-hidden" style={{ height }}>
              <div
                className="absolute left-0 top-0 h-full flex items-center px-3 transition-all duration-500"
                style={{
                  width: `${percentage}%`,
                  backgroundColor: item.color || '#1a5d3a'
                }}
              >
                {percentage > 20 && (
                  <span className="text-xs font-semibold text-white">
                    {formatCurrency(item.value)}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ValueComparisonBar;
